export default __webpack_public_path__ + "df4152ebd31834efe8b64148c5097824.gltf";